import { render, staticRenderFns } from "./details-left.vue?vue&type=template&id=16897918&scoped=true&"
import script from "./details-left.vue?vue&type=script&lang=ts&"
export * from "./details-left.vue?vue&type=script&lang=ts&"
import style0 from "./details-left.vue?vue&type=style&index=0&id=16897918&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16897918",
  null
  
)

export default component.exports